import { render, staticRenderFns } from "./TeacherCreation.vue?vue&type=template&id=124bd0e3&scoped=true&"
import script from "./TeacherCreation.vue?vue&type=script&lang=js&"
export * from "./TeacherCreation.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCreation.vue?vue&type=style&index=0&id=124bd0e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124bd0e3",
  null
  
)

export default component.exports